module.exports = __webpack_public_path__ + "assets/door-icon.253376a8.svg";